import { defineStore } from "pinia";
export const useDoacaoStore = defineStore("doacao", {
    state: () => ({
        isSalvando: false,
        isCarregando: false,
        isValidando: false,
        isCarregandoWhatsapp: false,
        inicializouPeloUsuarioLogado: false,
        campanha: {},
        doacao: {
            movimentacao: {
                nr_parcelas: 1,
            },
            aceita_receber_emails_marketing: true,
            concordo_termos_uso: true,
        },
        doacaoMaster: {},
        maxParcelas: 0,
        valores: [],
        validationErrors: [],
        recaptchaSiteKey: "",
        recaptchaDisabled: false,
        urlTermosUso: "",
        isLoadedStep: false,
    }),
    getters: {},
    actions: {
        setMaxParcelas(maxParcelas) {
            this.$state.maxParcelas = maxParcelas;
        },
        setDoacao(doacao) {
            this.$state.doacao = doacao;
        },
        setCampanha(campanha) {
            this.$state.campanha = campanha;
        },
        setValores(valores) {
            this.$state.valores = valores;
        },
        setRecaptchaSiteKey(key) {
            this.$state.recaptchaSiteKey = key;
        },
        setRecaptchaDisabled(disabled) {
            this.$state.recaptchaDisabled = disabled;
        },
        clearValidationErrors() {
            this.$state.validationErrors = [];
        },
        addValidationError(error) {
            this.$state.validationErrors.push(error);
        },
        setInicializouPeloUsuarioLogado(state) {
            this.$state.inicializouPeloUsuarioLogado = state;
        },
        setUrlTermosUso(url) {
            this.$state.urlTermosUso = url;
        },
    },
});
